"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInterceptor = void 0;
const interceptor_after_receive_1 = require("./interceptors/interceptor-after-receive");
const interceptor_before_reject_1 = require("./interceptors/interceptor-before-reject");
const addInterceptor = (axios) => {
    // noinspection TypeScriptValidateTypes
    axios.interceptors.response.use(
    // @ts-ignore
    interceptor_after_receive_1.interceptorAfterReceive, interceptor_before_reject_1.interceptorBeforeReject);
};
exports.addInterceptor = addInterceptor;
